import type { ProjectApiTypes } from '@highlight-cp/project-api';

/**
 * ### getBoxCountForProductFromTestGroup
 *
 * @description
 * Calculates the box count for a product from a single test group.
 * Formula: placements × countPerTester for the product in this test group
 *
 * @param testGroup - The test group to calculate from
 * @param productId - The ID of the product to calculate for
 * @returns The box count for the product from this test group
 */
const getBoxCountForProductFromTestGroup = (
  testGroup: ProjectApiTypes.AudienceBuilderTestGroup | undefined,
  productId: string | number,
): number => {
  if (!testGroup?.placements) {
    return 0;
  }

  const productInTestGroup = testGroup.products?.find((p) => p.productId === productId);
  const countPerTester = productInTestGroup?.countPerTester ?? 0;

  return testGroup.placements * countPerTester;
};

export default getBoxCountForProductFromTestGroup;
